export const HAND_HISTORY_LAYOUTS = {
  current: 'Current · Unified hand list',
  v1: 'V1 · Active / Completed',
  A: 'A · Hand cards',
  B: 'B · Pinned current hand',
  C: 'C · Continuous log',
  D: 'D · Hand navigator',
  E: 'E · Results first'
} as const;

export type HandHistoryLayout = keyof typeof HAND_HISTORY_LAYOUTS;

export const getHandHistoryLayout = (search: string): HandHistoryLayout => {
  const requested = new URLSearchParams(search).get('layout')?.trim().toLowerCase();
  return (
    (Object.keys(HAND_HISTORY_LAYOUTS) as HandHistoryLayout[]).find(
      (layout) => layout.toLowerCase() === requested
    ) ?? 'current'
  );
};
